// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"db813838","453":"64edc7d9"}[chunkId] + ".chunk.js";
};